import {
  Stack,
  TableCell,
  TableRow,
  Typography,
  useTheme
} from '@mui/material';
import { DateTime } from 'luxon';
import React from 'react';
import { useNavigate } from 'react-router-dom';



export type ClientReportRowProps = {
  id: string;
  startDate: DateTime;
  endDate: DateTime;
  createdAt: DateTime;
  approvedBy: string;
  approvedDate: DateTime | null;
  eventCount: {
    deliveries: number;
    milestones: number;
    inspections: number;
  };
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportRowProps) => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <TableRow
      onClick={() => navigate(`${props.id}`)}
      content='list'
    >
      <TableCell
        variant='firstRounded'

      >
        <Typography
          variant='tableCellBold'
          color={theme.palette.primary.main}
        >

          {props.startDate.toFormat('LLL dd, yyyy')} - {props.endDate.toFormat('LLL dd, yyyy')}
        </Typography>
      </TableCell>
      <TableCell
        variant='body'
      >
        <Stack
          direction='column'
        >
          <Typography
            variant='body1'
          >
            {props.approvedDate?.toFormat('LLL dd, yyyy') ?? '-'}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.approvedBy}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.eventCount.deliveries}
      </TableCell>
      <TableCell
        variant='body'
      >{props.eventCount.inspections}

      </TableCell>
      <TableCell
        variant='lastRounded'
      >
        {props.eventCount.milestones}
      </TableCell>
    </TableRow>
  );
};
